import { Checkbox } from '@pms-digital/design-system';

interface CaseSeSouvenirProps {
  /** Ticked when the form opens: the mock-up shows it ticked. */
  defaultChecked?: boolean;
}

/**
 * "se souvenir de moi": the `Checkbox` of the design system, a real `<input type="checkbox">`
 * (focusable, read by assistive technologies). The form reads it by its name through `FormData`.
 */
export function CaseSeSouvenir({ defaultChecked = false }: CaseSeSouvenirProps) {
  return <Checkbox name="seSouvenir" label="se souvenir de moi" defaultChecked={defaultChecked} />;
}
